<script>
import templatelist from "../components/automation-archive/template-list.vue";
import PageHeading from "../components/global/PageHeading.vue";
import { PLAN_SKU_TYPES } from "../utils/constants";

const { FREE_PLAN, SUSPENDED_PLAN, TRIAL_PLAN } = PLAN_SKU_TYPES;

export default {
  components: {
    templatelist,
    PageHeading,
  },
  data() {
    return {
      steps: [
        {
          target: "#email_templates_page_heading",
          content:
            "Save reusable email content here. Apply a template when sending messages or wire one into a workflow step.",
          params: { placement: "bottom" },
        },
      ],
      tourCallbacks: {
        onStop: () => window.$A.SaveCompletionOfProductTours("email-templates-page"),
      },
    };
  },
  computed: {
    isFreeUser() {
      const sub = _.get(this.$A, "Auth.account.subscriptionState", {});
      return sub.sku === FREE_PLAN || sub.sku === SUSPENDED_PLAN || sub.sku === TRIAL_PLAN;
    },
  },
  mounted() {
    this.$A.ClearViewData();
    window.$A.ProductTourProcess("email-templates-page", this);
  },
};
</script>

<template>
  <div class="nav-margin">
    <navigation></navigation>
    <PageHeading
      anchor-id="email_templates_page_heading"
      title="Email Templates"
      description="Reusable email content you can apply when sending messages or as part of a workflow."
    />
    <templatelist :isPaidAccount="!isFreeUser" />
    <v-tour name="email-templates-page" :steps="steps" :callbacks="tourCallbacks"></v-tour>
  </div>
</template>
